export default __webpack_public_path__ + "static/media/chart.12569474.svg";